module.exports = __webpack_public_path__ + "static/media/covid19-vaccines1-news.de172d64.jpg";